module.exports = __webpack_public_path__ + "img/phone-call.204e12e1.svg";